var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Edit"
}, /*#__PURE__*/React.createElement("path", {
  id: "edit-2",
  d: "M28.0572 29.5931H11.2085C10.8894 29.5931 10.5832 29.7198 10.3575 29.9455C10.1319 30.1712 10.0051 30.4773 10.0051 30.7965C10.0051 31.1157 10.1319 31.4218 10.3575 31.6475C10.5832 31.8732 10.8894 32 11.2085 32H28.0572C28.3764 32 28.6825 31.8732 28.9082 31.6475C29.1339 31.4218 29.2607 31.1157 29.2607 30.7965C29.2607 30.4773 29.1339 30.1712 28.9082 29.9455C28.6825 29.7198 28.3764 29.5931 28.0572 29.5931ZM11.2085 27.1861H11.3168L16.3353 26.7288C16.8851 26.674 17.3993 26.4318 17.7915 26.0428L28.6228 15.2115C29.0432 14.7674 29.2704 14.1747 29.2546 13.5634C29.2388 12.9521 28.9813 12.3719 28.5386 11.9501L25.2411 8.65257C24.8107 8.24832 24.2467 8.01637 23.6565 8.00083C23.0662 7.9853 22.4909 8.18727 22.0398 8.56833L11.2085 19.3996C10.8195 19.7919 10.5773 20.3061 10.5226 20.8558L10.0051 25.8743C9.98885 26.0506 10.0117 26.2283 10.072 26.3947C10.1324 26.5611 10.2287 26.7122 10.3541 26.8371C10.4665 26.9486 10.5999 27.0369 10.7465 27.0968C10.8931 27.1567 11.0501 27.187 11.2085 27.1861ZM23.5682 10.3374L26.8537 13.6229L24.4468 15.9697L21.2214 12.7444L23.5682 10.3374Z",
  fill: "black"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.89369a9c1c196b78a8dc98a9801bf296.svg";